const untranslatedPlaceholder = {
    zhHans: "（未翻译）",
    zhHant: "（未翻譯）",
    en: "(Not translated yet)",
    ms: "(Belum diterjemahkan)"
  };
  export default untranslatedPlaceholder;